import { useAppDispatch } from './useAppDispatcher.hook';
import { getEventsListThunk } from '../redux/ControlPanel/Events/Events.thunk';
import { Event } from '../redux/ControlPanel/Events/Events.type';

const useEventsHook = () => {
  const dispatch = useAppDispatch();

  return {
    getSelectList: async (
      search: string,
      loadedOptions: string | any[],
      { group, page }: any,
    ) => {
      const {
        payload: { data, pagination },
      }: { payload: any } = await dispatch(getEventsListThunk({ page }));

      return {
        options: data.map((item: Event) => ({
          value: item.code,
          label: item.name,
          eventId: item.id,
        })),
        hasMore: pagination.current_page < pagination.last_page,
        additional: {
          page: pagination.current_page + 1,
        },
      };
    },
  };
};

export default useEventsHook;
